export const getaccessToken = () => localStorage.getItem("accessToken")
export default getaccessToken
